import React, { Component } from 'react';
import { number } from 'prop-types';
import { Spin, Icon } from 'antd';
import Text from '../Text';
import { FlexContainer } from '..';

export default class ComponentLoading extends Component {
    static propTypes = {
        height: number,
        size: number
    }

    static defaultProps = {
        height: 74,
        size: 12
    }

    render () {
        const { height, size } = this.props;
        return (
            <FlexContainer height={`${height}px`} align='center'>
                <Spin indicator={<Icon type='loading' style={{ fontSize: size + 2 }} spin />} />
                <Text text='Cargando...' italic size={size} />
            </FlexContainer>
        );
    }
};
